const conversions = {
  Months: 2592000,
  Weeks: 604800,
  Days: 86400,
  Hours: 3600,
};

export function secondsToUnit(seconds) {
  if (!seconds) return { value: "", unit: "Hours" };

  for (const [unit, factor] of Object.entries(conversions)) {
    if (seconds >= factor) {
      return {
        value: Math.floor(seconds / factor),
        unit,
      };
    }
  }

  return { value: seconds / conversions.Hours, unit: "Hours" };
}

export function convertToSeconds(value, unit) {
  if (!value) return 0;

  return Number(value) * (conversions[unit] || conversions.Hours);
}

// Incident types shown as rows in the priority settings table, in display
// order. These are the backend `type` values, so they can be sent straight
// back in the incident_priority_matrix config.
export const PRIORITY_INCIDENT_TYPES = [
  "motion",
  "entry",
  "facility_motion",
  "temperature",
  "humidity",
];

export const MANAGER_ROLES = [
  "facility_manager",
  "regional_manager",
  "organization_manager",
];

export function defaultManagerNotificationSettings() {
  return MANAGER_ROLES.map((managerRole) => ({
    managerRole,
    email: false,
    robocall: false,
    slack: false,
    teams: false,
    sms: false,
    summaryReportingSettings: {
      dailyConcerningActivity: false,
      weeklyRegionalSummary: false,
      dailyFacilitySummary: false,
      weeklyFacilitySummary: false,
    },
  }));
}

// The stored incident_settings array is not in a guaranteed order — migrations
// append new types (temperature, water, humidity) to whatever an org already
// had — so always look settings up by type, never by array index.
export function findSettingByType(incidentSettings, type) {
  return (incidentSettings || []).find(
    (setting) => normalizeIncidentType(setting?.type) === type
  );
}

export function normalizeIncidentType(type) {
  return String(type || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
}

export const DEFAULT_MANAGE_OVERLOCKS_RULES = [
  {
    name: "Apply Overlocks",
    description: "Apply Overlocks to delinquent Units",
    schedule: "Automatic",
    detectedThreshold:
      "Please contact Support to update your Apply Overlocks settings.",
    priority: "substantial",
    status: "inactive",
    taskType: { name: "manage_overlocks" },
    isDefault: true,
    actions: { photoVideoRequired: false },
    notificationPreference: null,
    conditions: {
      event: "add_overlock",
    },
    frequency: {
      type: "daily",
      interval: 1,
    },
  },
  {
    name: "Remove Overlock(s)",
    description: "Remove Overlocks from Unit(s)",
    schedule: "Automatic",
    detectedThreshold: "PMS Driven - Outstanding balance paid",
    priority: "critical",
    status: "inactive",
    taskType: { name: "manage_overlocks" },
    isDefault: true,
    actions: { photoVideoRequired: false },
    notificationPreference: null,
    conditions: {
      event: "remove_overlock",
    },
    frequency: {
      type: "daily",
      interval: 1,
    },
  },
];
